import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Input, Tooltip, Space } from "antd";
import { Search as SearchIcon, RefreshCw, Plus, Users } from "react-feather";

const { Search } = Input;

function HeaderBar({
  search,
  setSearch,
  openAdd,
  refreshAll,
  waitStats, // optional (for subtitle)
}) {
  const subtitle = useMemo(() => {
    if (!waitStats) return "Manage walk-ins, queue, notify & seat guests.";
    const active = waitStats.activeCount ?? 0;
    const waiting = waitStats.waiting ?? 0;
    const notified = waitStats.notified ?? 0;
    return `Active: ${active} • Waiting: ${waiting} • Notified: ${notified}`;
  }, [waitStats]);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #eef2f7",
        borderRadius: 14,
        padding: 16,
        marginBottom: 12,
        boxShadow: "0 10px 30px rgba(17,24,39,.04)",
      }}
    >
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
        {/* Left */}
        <div className="d-flex align-items-center gap-3" style={{ minWidth: 220 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 14,
              display: "grid",
              placeItems: "center",
              background: "#f3f4f6",
              border: "1px solid #eef2f7",
            }}
          >
            <Users size={18} />
          </div>

          <div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "#111827", lineHeight: 1.1 }}>
              Waitlist
            </div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>{subtitle}</div>
          </div>
        </div>

        {/* Middle */}
        <div style={{ minWidth: 320, maxWidth: 420, flex: "1 1 320px" }}>
          <Search
            placeholder="Search guest name, phone, booking id…"
            allowClear
            enterButton={<SearchIcon size={16} />}
            size="large"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Right */}
        <Space wrap>
          <Tooltip title="Refresh">
            <Button
              icon={<RefreshCw size={16} />}
              onClick={() => refreshAll?.({ silent: false })}
            />
          </Tooltip>

          <Button type="primary" icon={<Plus size={16} />} onClick={openAdd}>
            Add Walk-in
          </Button>
        </Space>
      </div>

      <style>{`
        .ant-btn { border-radius: 10px; }
        .ant-input-search .ant-input { border-radius: 12px !important; }
        .ant-input-search .ant-input-group-addon .ant-btn {
          border-radius: 0 12px 12px 0 !important;
        }
      `}</style>
    </div>
  );
}

HeaderBar.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  openAdd: PropTypes.func.isRequired,      // ✅ same as before
  refreshAll: PropTypes.func.isRequired,    // ✅ same as before
  waitStats: PropTypes.object,              // optional
};

export default HeaderBar;
